import React from 'react';

import {useStaticQuery, graphql} from 'gatsby';
import * as paths from 'src/routes/paths';
import {Chevron} from 'src/svgs/chevron';

import {Maybe, SanityLabelledImage} from 'types/generated';

import {GridCard} from '../components/editorial/GridCard';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type InsightsNavigationProps = any;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const InsightsNavigation: React.FC<InsightsNavigationProps> = (props: InsightsNavigationProps) => {
  const data = useStaticQuery(graphql`
    query NavItems {
      allSanityTopic(sort: {order: ASC, fields: title}) {
        edges {
          node {
            id
            title
            slug {
              current
            }
            hideFromNav
            relatedCategories {
              id
              title
              slug {
                current
              }
              hideFromNav
            }
          }
        }
      }
      allSanitySeries {
        edges {
          node {
            id
            title
            slug {
              current
            }
            heroImage {
              altText
            }
            seriesIntroduction
            _rawHeroImage(resolveReferences: {maxDepth: 4})
            expirationDate(difference: "days")
            publishDate(difference: "days")
          }
        }
      }
      allSanityEditorial(filter: {isPodcast: {eq: true}}) {
        edges {
          node {
            _id
            title
          }
        }
      }
    }
  `);

  const topicsArray = data.allSanityTopic.edges;
  const seriesArray = data.allSanitySeries.edges;
  const hasSeries = seriesArray.length > 0;
  const hasPodcasts = data.allSanityEditorial.edges.length > 0;

  const isNotBgColor = ['bg-white', undefined, ''];

  const navItemParentColor =
    props.bgColor == 'bg-transparent'
      ? 'text-white'
      : isNotBgColor.indexOf(props.bgColor) > -1 || props.bgColor == 'bg-ivory'
      ? 'text-green-dark'
      : 'text-white';

  const navItemChildColor =
    props.bgColor == 'bg-transparent'
      ? 'text-green-dark'
      : isNotBgColor.indexOf(props.bgColor) > -1 || props.bgColor == 'bg-ivory'
      ? 'text-green-dark'
      : 'text-white';

  const chevronColor =
    props.bgColor == 'bg-transparent'
      ? 'fill-white'
      : isNotBgColor.indexOf(props.bgColor) > -1 || props.bgColor == 'bg-ivory'
      ? 'fill-green-dark'
      : 'fill-white';

  const isBgColor =
    props.bgColor == 'bg-transparent'
      ? 'group/isSeries isSeries'
      : isNotBgColor.indexOf(props.bgColor) > -1
      ? ''
      : 'group/isBgColor';

  const navBgColor =
    props.bgColor == 'bg-transparent'
      ? 'bg-transparent hover:bg-white transition-[backgroundColor] duration-150'
      : isNotBgColor.indexOf(props.bgColor) > -1
      ? 'bg-white'
      : props.bgColor;

  const bgColor =
    props.bgColor == 'bg-transparent'
      ? 'bg-white'
      : isNotBgColor.indexOf(props.bgColor) > -1
      ? 'bg-white'
      : props.bgColor;

  function filterSeries(textColor: string) {
    const filteredArray = seriesArray.filter(function (series: any) {
      return (
        (series.node.expirationDate == null || series.node.expirationDate.includes('-')) &&
        (series.node.publishDate == null || series.node.publishDate.toLowerCase().indexOf('-') === -1)
      );
    });

    const firstThree = filteredArray.slice(0, 3);
    return (
      <>
        {firstThree.map(
          (
            series: {
              node: {
                id: any;
                title: Maybe<string>;
                _rawHeroImage: Maybe<SanityLabelledImage>;
                slug: {
                  current: Maybe<string>;
                };
                seriesIntroduction: Maybe<string>;
                expirationDate: Maybe<string>;
              };
            },
            i: any,
          ) => (
            <li className="grid col-span-4 items-baseline" key={series.node.id}>
              <GridCard
                cardColClasses={'grid col-span-full lg:grid-cols-4 lg:gap-x-[26px] items-start pb-2'}
                title={series.node.title}
                image={series.node._rawHeroImage !== null ? series.node._rawHeroImage : null}
                imageClasses={'grid col-span-full lg:col-span-4 pb-[75%]'}
                contentClasses={'col-span-full lg:col-span-4 mt-4 lg:mt-7'}
                titleClasses={`type-eta mb-2 ${textColor}`}
                url={`/series/${series.node.slug?.current}`}
                slug={series.node.slug?.current}
                cardDescription={series.node.seriesIntroduction}
                cardDescriptionClasses={`type-sm-p normal-case ${textColor}`}
                eyebrowClasses={''}
                editorialCategory={undefined}
              />
            </li>
          ),
        )}
      </>
    );
  }

  return (
    <nav
      className={`px-gutter ease z-30 relative w-full hidden sm:block ${navBgColor} ${isBgColor}`}
      data-module="insights-navigation"
    >
      {/* Desktop */}
      <div className="wrapper-default lg:px-0 sm:bg-transparent grid grid-cols-1 md:grid-cols-2 min-[1375px]:flex xl:flex-row justify-between hidden">
        {!props.isListing && <div className="h-[1px] top-[76px] w-full bg-light-gold absolute z-[100]"></div>}
        <ul
          role="list"
          className="insights-navigation-menu hidden sm:mt-0 sm:hidden grid-colss-1 lg:flex xl:flex-wrap w-full lg:max-w-max items-start sm:justify-between sm:gap-x-8 lg:gap-x-1"
        >
          <li className="py-4">
            <a
              className="font-sans text-[21px] font-bold lg:pr-[5px] xl:pr-[11px] lg:py-[14px] text-left leading-[23px] tracking-[2%]"
              href="/articles"
            >
              Thought
              <br />
              Leadership
            </a>
          </li>
          {topicsArray?.map(
            (
              topic: {
                node: {
                  id: string;
                  slug: {current: Maybe<string>};
                  title: string;
                  relatedCategories: any[];
                  hideFromNav: boolean;
                };
              },
              i: number,
            ) =>
              topic.node.hideFromNav != true ? (
                <li
                  key={topic.node.id || i}
                  className={`nav-item-parent py-4 static group sm:border-0 flex flex-col lg:flex-row w-full text-12px font-medium uppercase lg:max-w-max `}
                >
                  <a
                    href={`${paths.TOPIC}/${topic.node.slug?.current}`}
                    target="_self"
                    className={`flex items-center w-full min-w-max lg:max-w-max py-5 lg:px-[5px] xl:px-[11px] lg:py-[14px]  sm:group-hover:bg-ivory sm:group-hover:text-green-dark sm:focus:bg-ivory sm:active:bg-ivory sm:visited:bg-ivory rounded sm:border sm:border-transparent ${navItemParentColor}`}
                  >
                    <span>{topic.node.title}</span>
                    <Chevron
                      classes={`w-[9px] h-[7px] ml-2 transition-all sm:group-hover:fill-green-dark linear duration-300 group-hover:rotate-180 group-hover/isSeries:fill-green-dark ${chevronColor} }`}
                    />
                  </a>
                  {/* Topics Dropdown Desktop */}
                  {topic.node.relatedCategories?.length > 0 && (
                    <div
                      className={`nav-item-child absolute right-0 left-0 w-screen lg:ml-[calc(-50vw+50%)] opacity-0 lg:group-hover:opacity-100 lg:group-hover:block transtion-all duration-300 ease-in-out px-gutter transition ${bgColor}`}
                    >
                      <div className="wrapper-default">
                        <ul className="w-full flex space-x-4 lg:space-x-8 flex-wrap justify-start py-4">
                          {topic.node.relatedCategories?.map(category =>
                            category.hideFromNav != true && category.slug?.current ? (
                              <li
                                className={`py-2 type-lota col-span-1 min-w-max text-center sm:text-left normal-case hover:underline ${navItemChildColor}`}
                                key={category.id}
                              >
                                <a href={`${paths.CATEGORY}/${category.slug.current}`}>{category.title}</a>
                              </li>
                            ) : null,
                          )}
                        </ul>
                      </div>
                    </div>
                  )}
                </li>
              ) : null,
          )}
          {/* Series */}
          {hasSeries && (
            <li
              className={`nav-item-parent py-4 static group flex flex-col lg:flex-row w-full text-12px font-medium uppercase lg:max-w-max lg:6 ${navItemParentColor}`}
            >
              <div className="nav-series flex items-center w-full min-w-max lg:max-w-max py-5 lg:px-[5px] xl:px-[11px] lg:py-[14px] sm:group-hover:bg-ivory sm:group-hover:text-green-dark sm:focus:bg-ivory sm:active:bg-ivory sm:visited:bg-ivory rounded sm:border sm:border-transparent">
                <span>Series</span>
                <Chevron
                  classes={`w-[9px] h-[7px] ml-2 transition-all linear duration-300 group-hover:fill-green-dark group-hover:rotate-180 group-hover/isSeries:fill-green-dark ${chevronColor} }`}
                />
              </div>
              <div
                className={`nav-item-child-series px-gutter pb-5 absolute  right-0 left-0  w-screen lg:ml-[calc(-50vw+50%)] shadow-lg ${bgColor}`}
              >
                <ul role="list" className="wrapper-default grid grid-cols-4 md:grid-cols-12 gap-8 pt-12 pb-14">
                  <>{filterSeries(navItemChildColor)}</>
                </ul>
              </div>
            </li>
          )}

          {/* Podcasts */}
          {hasPodcasts && (
            <li
              className={`nav-item py-4 static group flex flex-col lg:flex-row w-full text-12px font-medium uppercase lg:max-w-max lg:6 ${navItemParentColor}`}
            >
              <a
                href={`${paths.PODCAST}/`}
                target="_self"
                className={`flex items-center w-full min-w-max lg:max-w-max py-5 lg:px-[5px] xl:px-[11px] lg:py-[14px]  sm:group-hover:bg-ivory sm:group-hover:text-green-dark sm:focus:bg-ivory sm:active:bg-ivory sm:visited:bg-ivory rounded sm:border sm:border-transparent ${navItemParentColor}`}
              >
                Podcast
              </a>
            </li>
          )}
        </ul>
      </div>
      {/* Tablet */}
      <div className="min-[1375px]:hidden nav-tablet md:block hidden relative">
        {!props.isListing && <div className="h-[1px] top-[76px] w-full bg-light-gold absolute z-[100]"></div>}
        <ul role="list" className="insights-navigation-menu flex w-full max-w-max items-start gap-x-4">
          <li className="py-4 pr-4">
            <a
              className="font-sans text-[16px] lg:text-[21px] font-bold lg:pr-[5px] xl:pr-[11px] lg:py-[14px] text-left lg:leading-[23px] lg:tracking-[2%]"
              href="/articles"
            >
              Thought
              <br />
              Leadership
            </a>
          </li>
          <li
            className={`nav-item-parent nav-item-parent-categories py-4 static group flex flex-col lg:flex-row w-full text-12px font-medium uppercase lg:max-w-max lg:6 ${navItemParentColor}`}
          >
            <div className="cursor-pointer flex items-center w-full min-w-max lg:max-w-max py-5 px-[5px] xl:px-[11px] lg:py-[14px] sm:group-hover:bg-ivory sm:group-hover:text-green-dark sm:focus:bg-ivory sm:active:bg-ivory sm:visited:bg-ivory rounded sm:border sm:border-transparent">
              <span>Categories</span>
              <Chevron
                classes={`w-[9px] h-[7px] ml-2 transition-all linear duration-300 group-hover:fill-green-dark group-hover:rotate-180 group-hover/isSeries:fill-green-dark ${chevronColor} }`}
              />
            </div>
            <div
              className={`nav-item-child absolute right-0 left-0 w-screen ml-[calc(-50vw+50%)] opacity-0 group-hover:opacity-100 group-hover:block transtion-all duration-300 ease-in-out px-gutter transition ${bgColor}`}
            >
              <ul role="list" className="pb-14 grid grid-cols-3 gap-8">
                {topicsArray?.map(
                  (
                    topic: {
                      node: {
                        id: string;
                        slug: {current: Maybe<string>};
                        title: string;
                        relatedCategories: any[];
                        hideFromNav: boolean;
                      };
                    },
                    i: number,
                  ) =>
                    topic.node.hideFromNav != true ? (
                      <li
                        key={topic.node.id || i}
                        className={`static group sm:border-0 flex flex-col w-full text-12px font-medium uppercase lg:max-w-max `}
                      >
                        <a
                          href={`${paths.TOPIC}/${topic.node.slug?.current}`}
                          target="_self"
                          className="mb-4 flex items-center w-full min-w-max lg:max-w-max sm:group-hover:text-green-dark sm:focus:bg-ivory sm:active:bg-ivory sm:visited:bg-ivory rounded sm:border sm:border-transparent"
                        >
                          <span>{topic.node.title}</span>
                        </a>
                        {/* Topics Dropdown Tablet */}
                        {topic.node.relatedCategories?.length > 0 && (
                          <div className={`${bgColor}`}>
                            <ul className="w-full flex flex-wrap flex-col justify-start gap-y-3">
                              {topic.node.relatedCategories?.map(category =>
                                category.hideFromNav != true && category.slug?.current ? (
                                  <li
                                    className={`type-lota min-w-max text-center sm:text-left normal-case hover:underline ${navItemChildColor}`}
                                    key={category.id}
                                  >
                                    <a href={`${paths.CATEGORY}/${category.slug.current}`}>{category.title}</a>
                                  </li>
                                ) : null,
                              )}
                            </ul>
                          </div>
                        )}
                      </li>
                    ) : null,
                )}
              </ul>
            </div>
          </li>
          {hasSeries && (
            <li
              className={`nav-item-parent py-4 static group flex flex-col lg:flex-row w-full text-12px font-medium uppercase lg:max-w-max lg:6 ${navItemParentColor}`}
            >
              <div className="nav-series flex items-center w-full min-w-max lg:max-w-max py-5 lg:px-[5px] xl:px-[11px] lg:py-[14px] sm:group-hover:bg-ivory sm:group-hover:text-green-dark sm:focus:bg-ivory sm:active:bg-ivory sm:visited:bg-ivory rounded sm:border sm:border-transparent">
                <span>Series</span>
                <Chevron
                  classes={`w-[9px] h-[7px] ml-2 transition-all linear duration-300 group-hover:fill-green-dark group-hover:rotate-180 group-hover/isSeries:fill-green-dark ${chevronColor} }`}
                />
              </div>
              <div
                className={`nav-item-child-series px-gutter pb-5 absolute  right-0 left-0  w-screen lg:ml-[calc(-50vw+50%)] shadow-lg ${bgColor}`}
              >
                <ul role="list" className="wrapper-default grid grid-cols-4 md:grid-cols-12 gap-8 pt-12 pb-14">
                  <>{filterSeries(navItemChildColor)}</>
                </ul>
              </div>
            </li>
          )}

          {/* Podcasts */}
          {hasPodcasts && (
            <li
              className={`nav-item py-4 static group flex flex-col lg:flex-row w-full text-12px font-medium uppercase lg:max-w-max lg:6 ${navItemParentColor}`}
            >
              <a
                href={`${paths.PODCAST}/`}
                target="_self"
                className={`flex items-center w-full min-w-max lg:max-w-max py-5 lg:px-[5px] xl:px-[11px] lg:py-[14px]  sm:group-hover:bg-ivory sm:group-hover:text-green-dark sm:focus:bg-ivory sm:active:bg-ivory sm:visited:bg-ivory rounded sm:border sm:border-transparent ${navItemParentColor}`}
              >
                Podcast
              </a>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};
